import React, { useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal } from "reactstrap";
import ModalTitle from "../../UpdateModels/ModalTitle";
import ModelCategory from "../../UpdateModels/ModelCategory";
import ModelSubCategory from "../../UpdateModels/ModelSubCategory";
import ModalDescription from "../../UpdateModels/ModalDescription";
import ModelDuretion from "../../UpdateModels/ModelDuretion";
import ModelBudget from "../../UpdateModels/ModelBudget";
import ModelLanguage from "../../UpdateModels/ModelLanguage";
import ModelDeliverables from "../../UpdateModels/ModelDeliverables";
import ModelFile from "../../UpdateModels/ModelFile";
import ModelSkills from "../../UpdateModels/ModelSkills";
import ModelMilestones from "../../UpdateModels/ModelMilestones";
import ModelType from "../../UpdateModels/ModelType";
import axiosInstance from "../../../../../redux/api";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { urtoast } from "../../../../Layouts/CustomPopup/eventEmitter";
import ButtonLoader from "../../../../Common/Loader/ButtonLoader";
import DisplayFileProper from "../../../../Common/FilesRelevent/DisplayFileProper";
import { Tooltip } from "react-tooltip";
import { addpresent } from "../../../../Common/FewCommonMethods";
import { formatNumberWithCommas } from "../../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import ModalIndustry from "../../UpdateModels/ModalIndustry";
import { descriptionvalidation, titlevalidation } from "../../../../Common/commonvalidation";
import { isDurationLessThanMilestones } from "../../../../../utils/isDurationLessThanMilestones";
import { isPriceWithinBudget } from "../../../../../utils/isPriceWithinBudget";
import MilestonesDisplay from "../../../../Common/MilestonesDisplay";
import useEnterKeySubmit from "../../../../../utils/useEnterKeySubmit";
import CompetencieswithioutComma from "../../../../Common/CompetencieswithioutComma";
import { penaltytips } from "../../../../Common/Tooltips/tooltip";

export default function PReviewProject({ formData, setFormData, setX }) {
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const [modaltitle, setModaltitle] = useState(false);
  const [title, setTitle] = useState(formData.title);
  const [modalcategory, setModalCategory] = useState(false);
  const [industryEditModal, setIndustryEditModal] = useState(false);
  const [category, setCategory] = useState(formData?.category_index);
  const [modalsubcategory, setModalSubCategory] = useState(false);
  const [modaldescription, setModalDescription] = useState(false);
  const [description, setDescription] = useState(formData.description);
  const [modalduretion, setModalduretion] = useState(false);
  const [duration, setProjectduration] = useState(formData.duration);
  const [modalBudget, setModalBudget] = useState(false);
  const [price, setProjectbudget] = useState(formData.price);
  const [modalLanguage, setModalLanguege] = useState(false);
  const [language_id, setLanguege] = useState(formData.language_id);
  const [modaldeliverables, setModaldeliverables] = useState(false);
  const [deliverables, setExpecteddeliverables] = useState(
    formData.deliverables
  );
  const [modalfile, setModalFile] = useState(false);
  const [modalSkills, setModalSkills] = useState(false);
  const [modalMils, setModalMils] = useState(false);
  const [modaltype, setModaltype] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setFormData(formData);
  }, [formData]);

  const hitApi = () => {
    const data = {
      ...formData,
      title: title,
      description: description,
      price: price,
      deliverables: deliverables,
    };
    setFormData(data);
  };

  const handleInputTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleInputDescription = (e) => {
    setDescription(e.target.value);
  };
  const handleInputDuretion = (e) => {
    setProjectduration(e.target.value);
  };
  const handleInputBudget = (e) => {
    setProjectbudget(e.target.value);
  };
  const handleInputExpecteddeliverables = (e) => {
    setExpecteddeliverables(e.target.value);
  };

  const handleSubmit = async (values, formikHelpers) => {
    const isDurationValid = isDurationLessThanMilestones(
      values.duration,
      values.duration_type,
      values.milestones
    );

    const isBudgetValid = isPriceWithinBudget(values.price, values.milestones);

    if (!isDurationValid || !isBudgetValid) {
      formikHelpers.setErrors({
        duration: !isDurationValid
          ? "Total milestone duration cannot exceed total project duration."
          : undefined,
        price: !isBudgetValid
          ? "Total milestone amounts cannot exceed project budget."
          : undefined,
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axiosInstance.post("post/create", formData);

      if (response.data.status) {
        navigate(`/${lan}/postsuccessful`, {
          state: { response: response?.data?.response, type: "project" },
        });
      } else {
        // API returned false status
        urtoast(response?.data?.message || "Something went wrong", 2);
      }

      await new Promise((resolve) => setTimeout(resolve, 2000));

    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||   // backend message
        error?.response?.data?.error ||     // fallback
        error?.message ||                   // axios message
        "Something went wrong";

      urtoast(errorMsg, 2);
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };
  const validationSchema = Yup.object().shape({
    type: Yup.string().required("This is required"),
    title: titlevalidation,
    industry_id: Yup.string().required("This is required"),
    category_id: Yup.string().required("This is required"),
    // sub_category_id: Yup.string().required('This is required'),
    description: descriptionvalidation,
    skills: Yup.array().required("This is required"),
    price: Yup.string().required("This is required"),
    duration: Yup.string().required("Duration Type is required"),
    duration_type: Yup.string().required("Duration is required"),
    // milestones: Yup.array().min(1, 'At least one milestone is required').required('This is required'),
    // files: Yup.array().min(1, 'At least one file is required').required('This is required'),
    deliverables: Yup.string().required("This is required"),
    language_id: Yup.string().required("This is required"),
  });

  useEnterKeySubmit(handleSubmit);

  return (
    <div className="bg-project">
      <Formik
        initialValues={formData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            { }

            <div>
              <div className="col-lg-10   mx-auto project-det">
                <div className="project-first">
                  <h4>
                    {formData?.type == 1
                      ? "Post & Browse Projects (PBP)"
                      : formData?.type == 2
                        ? "Contest"
                        : formData?.type == 3
                          ? "Job"
                          : ""}{" "}
                    Summary
                  </h4>


                </div>
                <div className="project-row">
                  <div className="project-section">
                    <div>
                      <p>Project Title</p>
                      <h4>{formData?.title}</h4>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModaltitle(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error"
                  />
                  <div className="project-section">
                    <div>
                      <p>Industry</p>
                      <h4>{formData?.industry_index?.label}</h4>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setIndustryEditModal(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Category</p>
                      <h4>{formData?.category_index?.label}</h4>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModalCategory(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="category_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Sub-Category</p>
                      <h4>{formData?.subcategory_index?.label}</h4>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModalSubCategory(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="sub_category_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Description</p>
                      <CustomReactQuillDescription
                        value={formData?.description}
                      />
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModalDescription(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>

                  <ErrorMessage
                    name="description"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Competencies</p>
                      <CompetencieswithioutComma formData={formData} />
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModalSkills(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="skills"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Budget</p>
                      <h4>
                        {formData?.price && "$ "}
                        {formatNumberWithCommas(formData?.price)}
                      </h4>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModalBudget(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="price"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Deadline</p>
                      <h4>
                        {formData?.duration} &nbsp;
                        {formData?.duration_type == 2
                          ? "Days"
                          : formData?.duration_type == 3
                            ? "Weeks"
                            : formData?.duration_type == 4
                              ? "Months"
                              : ""}
                      </h4>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModalduretion(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>

                  <ErrorMessage
                    name="duration_type"
                    component="div"
                    className="error"
                  />
                  <ErrorMessage
                    name="duration"
                    component="div"
                    className="error"
                  />

                  <>
                    <div className="project-section">
                      <div className="w-100">
                        <p className="d-flex justify-content-between align-items-center">Milestones   <span
                          className="btn"
                          onClick={() => {
                            setModalMils(true);
                          }}
                        >
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                            alt=""
                          />
                        </span></p>
                        {(Array.isArray(formData?.milestones) && formData?.milestones?.length > 0) ? (
                          <>
                            <MilestonesDisplay formData={formData} />
                          </>
                        ) :
                          <p className="d-flex">No milestone created</p>
                        }
                      </div>

                    </div>
                    <ErrorMessage
                      name="milestones"
                      component="div"
                      className="error"
                    />
                  </>

                  <div className="project-section">
                    <div className="w-100">
                      <p>Attachments</p>
                      <div className="images image-row1 row">
                        {Array.isArray(formData.files) &&
                          formData.files?.length > 0 ? (
                          <>
                            {formData.files.map((item, index) => (
                              <div className="col-md-4" key={index}>
                                <DisplayFileProper item={item} />
                              </div>
                            ))}
                          </>
                        ) : (
                          <p className="text-muted">
                            {/* <i className="fas fa-info-circle"></i> Please attach
                            the required files to proceed. */}
                          </p>
                        )}
                      </div>
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModalFile(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="files"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Expected deliverables</p>
                      <CustomReactQuillDescription
                        value={formData?.deliverables}
                      />
                    </div>
                    <span
                      className="btn"
                      onClick={() => {
                        setModaldeliverables(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="deliverables"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Preferred Language of Work Submission</p>
                      <h4>{formData?.languageindex?.label}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalLanguege(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="language_id"
                    component="div"
                    className="error"
                  />
                </div>
                <div >
                  {loading ? (
                    <ButtonLoader />
                  ) : (
                    <button type="submit" className="summary-post-job" disabled={loading} onClick={formik.handleSubmit}>
                      Post{" "}
                      {formData?.type == 1
                        ? "Project"
                        : formData?.type == 2
                          ? "Contest"
                          : formData?.type == 3
                            ? "Job"
                            : ""}
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                        alt=""
                      />
                    </button>
                  )}
                </div>
              </div>
              <Modal
                className="popupmodal yes-no"
                isOpen={modaltitle}
                toggle={() => setModaltitle((state) => !state)}
              >
                <ModalTitle
                  title={title}
                  setModaltitle={setModaltitle}
                  handleInputTitle={handleInputTitle}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={industryEditModal}
                toggle={() => setIndustryEditModal((state) => !state)}
              >
                <ModalIndustry
                  formData={formData}
                  setFormData={setFormData}
                  setIndustryEditModal={setIndustryEditModal}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalcategory}
                toggle={() => setModalCategory((state) => !state)}
              >
                <ModelCategory
                  formData={formData}
                  setFormData={setFormData}
                  category={category}
                  setModalCategory={setModalCategory}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalsubcategory}
                toggle={() => setModalSubCategory((state) => !state)}
              >
                <ModelSubCategory
                  parentid={formData.category_id}
                  formData={formData}
                  setFormData={setFormData}
                  setModalSubCategory={setModalSubCategory}
                />
              </Modal>
              <Modal
                className="popupmodal yes-no"
                isOpen={modaldescription}
                toggle={() => setModalDescription((state) => !state)}
              >
                <ModalDescription
                  setFormData={setFormData}
                  description={description}
                  setModalDescription={setModalDescription}
                  handleInputDescription={handleInputDescription}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal yes-no"
                isOpen={modalSkills}
                toggle={() => setModalSkills((state) => !state)}
              >
                <ModelSkills
                  formData={formData}
                  setFormData={setFormData}
                  setModalSkills={setModalSkills}
                />
              </Modal>
              <Modal
                className="popupmodal yes-no"
                isOpen={modalBudget}
                toggle={() => setModalBudget((state) => !state)}
              >
                <ModelBudget
                  price={price}
                  setModalBudget={setModalBudget}
                  handleInputBudget={handleInputBudget}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalduretion}
                toggle={() => setModalduretion((state) => !state)}
              >
                <ModelDuretion
                  formData={formData}
                  setFormData={setFormData}
                  duration={duration}
                  setModalduretion={setModalduretion}
                  handleInputDuretion={handleInputDuretion}
                  hitApi={hitApi}
                />
              </Modal>

              <Modal
                className="popupmodal"
                isOpen={modalfile}
                toggle={() => setModalFile((state) => !state)}
              >
                <ModelFile
                  formData={formData}
                  setFormData={setFormData}
                  setModalFile={setModalFile}
                />
              </Modal>
              <Modal
                size="xl"
                className="popupmodal"
                isOpen={modalMils}
                toggle={() => setModalMils((state) => !state)}
              >
                <ModelMilestones
                  formData={formData}
                  setFormData={setFormData}
                  setModalMils={setModalMils}
                />
              </Modal>

              <Modal
                className="popupmodal"
                isOpen={modaldeliverables}
                toggle={() => setModaldeliverables((state) => !state)}
              >
                <ModelDeliverables
                  setFormData={setFormData}
                  deliverables={deliverables}
                  setModaldeliverables={setModaldeliverables}
                  handleInputExpecteddeliverables={
                    handleInputExpecteddeliverables
                  }
                  hitApi={hitApi}
                />
              </Modal>

              <Modal
                className="popupmodal"
                isOpen={modalLanguage}
                toggle={() => setModalLanguege((state) => !state)}
              >
                <ModelLanguage
                  formData={formData}
                  setFormData={setFormData}
                  language_id={language_id}
                  setModalLanguege={setModalLanguege}
                />
              </Modal>

              <Modal
                className="popupmodal"
                isOpen={modaltype}
                toggle={() => setModaltype((state) => !state)}
              >
                <ModelType
                  formData={formData}
                  setFormData={setFormData}
                  setModaltype={setModaltype}
                />
              </Modal>
            </div>
          </Form>
        )}
      </Formik>
      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content={penaltytips}
      />
    </div>
  );
}
